import Heading from "components/ui/Heading/Heading";
import PropTypes from "prop-types";
import AddButton from "components/ui/Button/AddButton/AddButton";
import ComponentAccessControl from "components/essentials/ComponentAccessControl/ComponentAccessControl";
import { baseResources, baseResourceActions } from "routes/enum";

const { KB_SAM_ISSUE_CONVERSATION } = baseResources;
const { CREATE } = baseResourceActions;

const QaDocumentationHeader = ({
    toggleModal,
}) => {
    return (
        <>
            <Heading
                headingText={"LLM Documentation"}
                headingSubText={"Add & change your LLM Documentation"}
            />
            <div className='issues-heading'>
                <div>
                </div>
                <div>
                    <ComponentAccessControl
                        baseResources={[
                            `${CREATE}_${KB_SAM_ISSUE_CONVERSATION}`,
                        ]}>
                        <AddButton
                            btnText='Create New LLM Document'
                            onClick={toggleModal}
                        />
                    </ComponentAccessControl>
                </div>
            </div>
        </>
    );
};

QaDocumentationHeader.prototypes = {
    getIssues: PropTypes.func.isRequired,
    setSearchValue: PropTypes.func.isRequired,
    issues: PropTypes.array.isRequired,
    clearSearch: PropTypes.bool,
};

export default QaDocumentationHeader;
